/* eslint react/jsx-boolean-value: 0 */

import React, { Fragment } from 'react'
import config from 'app-config'
import Loadable from 'react-loadable'
import { Redirect, Route } from 'react-router-dom'
import { Switch } from 'sb-react-router'
import { constants, getAbValue, links } from 'common/helpers'

import Loader from 'components/loaders/Loader/Loader'
import App from 'containers/App/App'
import HasAuth from 'containers/HasAuth/HasAuth'
import Page404 from 'pages/404/404' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/500/500' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/seo/BrandsPage/BrandsPage' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/seo/CommonPage/CommonPage' // DON'T REMOVE THIS! THIS IS FOR SSR!
import 'pages/seo/NotePage/NotePage' // DON'T REMOVE THIS! THIS IS FOR SSR!
import CheckHelmet from 'pages/CheckHelmet/CheckHelmet'


const loading = Loader


// Containers


// Layous

const InsideLayout                    = Loadable({ loader: () => import('layouts/InsideLayout/InsideLayout'), loading })
const HumbleLayout                    = Loadable({ loader: () => import('layouts/HumbleLayout/HumbleLayout'), loading })
const LandingLayout                   = Loadable({ loader: () => import('layouts/LandingLayout/LandingLayout'), loading })
const SubscriptionLayout              = Loadable({ loader: () => import('layouts/SubscriptionLayout/SubscriptionLayout'), loading })
const ProfileLayout                   = Loadable({ loader: () => import('layouts/ProfileLayout/ProfileLayout'), loading })
const UserProfileLayout               = Loadable({ loader: () => import('layouts/UserProfileLayout/UserProfileLayout'), loading })
const ProfileSubscriptionLayout       = Loadable({ loader: () => import('layouts/ProfileSubscriptionLayout/ProfileSubscriptionLayout'), loading })
const ProfileContentLayout            = Loadable({ loader: () => import('layouts/ProfileContentLayout/ProfileContentLayout'), loading })
const WithoutHeaderLayout             = Loadable({ loader: () => import('layouts/WithoutHeaderLayout/WithoutHeaderLayout'), loading })


// Pages


const NoMatch                         = Loadable({ loader: () => import('pages/NoMatch/NoMatch'), loading })

// promo
const TossInPage                      = Loadable({ loader: () => import('pages/TossInPage/TossInPage'), loading })
const BuyQueuePage                    = Loadable({ loader: () => import('pages/BuyQueuePage/BuyQueuePage'), loading })

// pick your scent
const CasesSubscriptionPage           = Loadable({ loader: () => import('pages/pickYourScentFlow/CasesSubscriptionPage/CasesSubscriptionPage'), loading })
const WelcomePage                     = Loadable({ loader: () => import('pages/pickYourScentFlow/WelcomePage/WelcomePage'), loading })
const PickPage                        = Loadable({ loader: () => import('pages/pickYourScentFlow/PickPage/PickPage'), loading })
const MakeupLandingPage               = Loadable({ loader: () => import('pages/MakeupLandingPage/MakeupLandingPage'), loading })
const SkincareIntroPage               = Loadable({ loader: () => import('pages/SkincareIntroPage/SkincareIntroPage'), loading })
const MixPage                         = Loadable({ loader: () => import('pages/mix/MixPage/MixPage'), loading })
const MixWelcomePage                  = Loadable({ loader: () => import('pages/mix/MixWelcomePage/MixWelcomePage'), loading })

// plan
const PlanPage                        = Loadable({ loader: () => import('pages/PlanPage/PlanPage'), loading })

// payment
const SubscribePage                   = Loadable({ loader: () => import('pages/payment/SubscribePageConductor'), loading })
const PaymentPage                     = Loadable({ loader: () => import('pages/payment/PaymentPage/PaymentPage'), loading })
const GiftCardPaymentPage             = Loadable({ loader: () => import('pages/payment/GiftCardPaymentPage/GiftCardPaymentPage'), loading })
const GiftSubscriptionPaymentPage     = Loadable({ loader: () => import('pages/payment/GiftSubscriptionPaymentPage/GiftSubscriptionPaymentPage'), loading })
const GiftSubscriptionRedeemPage      = Loadable({ loader: () => import('pages/payment/GiftSubscriptionRedeemPage/GiftSubscriptionRedeemPage'), loading })
const RedeemCouponPage                = Loadable({ loader: () => import('pages/payment/RedeemCouponPage/RedeemCouponPage'), loading })

// new payment
const NewSubscribePage                = Loadable({ loader: () => import('pages/paymentNew/SubscribePage/SubscribePage'), loading })
const RedeemQueuePage                 = Loadable({ loader: () => import('pages/paymentNew/RedeemQueuePage/RedeemQueuePage'), loading })
const RedeemTossInPage                = Loadable({ loader: () => import('pages/paymentNew/RedeemTossInPage/RedeemTossInPage'), loading })
const SubscribePrototypePage          = Loadable({ loader: () => import('pages/paymentNew/SubscribePrototypePage/SubscribePrototypePage'), loading })

// products
const ProductsPage                    = Loadable({ loader: () => import('pages/ProductsPage/ProductsPage'), loading })
const CosmeticsProductsPage           = Loadable({ loader: () => import('pages/CosmeticsProductsPage/CosmeticsProductsPage'), loading })
const CosmeticsProductsPageNew        = Loadable({ loader: () => import('pages/CosmeticsProductsPageNew/CosmeticsProductsPageNew'), loading })
const HowHandCreamsWorkPage           = Loadable({ loader: () => import('pages/howItWorksPages/HowHandCreamsWorkPage/HowHandCreamsWorkPage'), loading })
const HowItWorksPage                  = Loadable({ loader: () => import('pages/howItWorksPages/HowItWorksPage/HowItWorksPage'), loading })
const ProductPage                     = Loadable({ loader: () => import('pages/ProductPage/ProductPage'), loading })

// profile
const OrdersStatusPage                = Loadable({ loader: () => import('pages/profile/OrdersStatusPage/OrdersStatusPage'), loading })
const ReceivedProductsPage            = Loadable({ loader: () => import('pages/profile/ReceivedProductsPage/ReceivedProductsPage'), loading })
const UpgradeSubscriptionPage         = Loadable({ loader: () => import('pages/profile/UpgradeSubscriptionPage/UpgradeSubscriptionPage'), loading })
const ProductsInQueuePage             = Loadable({ loader: () => import('pages/profile/ProductsInQueuePage/ProductsInQueuePage'), loading })
const RatedProductsPage               = Loadable({ loader: () => import('pages/profile/RatedProductsPage/RatedProductsPage'), loading })
const ReviewsPage                     = Loadable({ loader: () => import('pages/profile/ReviewsPage/ReviewsPage'), loading })
const BillingAndShippingPage          = Loadable({ loader: () => import('pages/profile/BillingAndShippingPage/BillingAndShippingPage'), loading })
const UpdatePasswordPage              = Loadable({ loader: () => import('pages/profile/UpdatePasswordPage/UpdatePasswordPage'), loading })
const SentGiftsPage                   = Loadable({ loader: () => import('pages/profile/SentGiftsPage/SentGiftsPage'), loading })
const MyOrdersPage                    = Loadable({ loader: () => import('pages/profile/MyOrdersPage/MyOrdersPage'), loading })
const OrderInfoPage                   = Loadable({ loader: () => import('pages/profile/OrderInfoPage/OrderInfoPage'), loading })
const PersonalPage                    = Loadable({ loader: () => import('pages/profile/PersonalPage/PersonalPage'), loading })

// subscription
const UnpausePage                     = Loadable({ loader: () => import('pages/UnpausePage/UnpausePage'), loading })
const ResubscribePage                 = Loadable({ loader: () => import('pages/ResubscribePage/ResubscribePage'), loading })
const CancelSubscriptionPage          = Loadable({ loader: () => import('pages/CancelSubscriptionPage/CancelSubscriptionPage'), loading })

// card update
const CardUpdatePage                  = Loadable({ loader: () => import('pages/CardUpdatePage/CardUpdatePage'), loading })
const CaseCardUpdatePage              = Loadable({ loader: () => import('pages/CaseCardUpdatePage/CaseCardUpdatePage'), loading })

// blogger
const BloggerPage                     = Loadable({ loader: () => import('pages/BloggerPage/BloggerPage'), loading })

// common
const DowngradePage                   = Loadable({ loader: () => import('pages/DowngradePage/DowngradePage'), loading })
const UpgradePage                     = Loadable({ loader: () => import('pages/upgrade/UpgradePage/UpgradePage'), loading })
const UpgradePlanWithDiscountPage     = Loadable({ loader: () => import('pages/upgrade/UpgradePlanWithDiscountPage/UpgradePlanWithDiscountPage'), loading })
const UpgradeProductPage              = Loadable({ loader: () => import('pages/upgrade/UpgradeProductPage/UpgradeProductPage'), loading })
const UpgradePrepaidPage              = Loadable({ loader: () => import('pages/upgrade/UpgradePrepaidPage/UpgradePrepaidPage'), loading })
const UpgradeSimplePage               = Loadable({ loader: () => import('pages/upgrade/UpgradeSimplePage/UpgradeSimplePage'), loading })
const TeamPage                        = Loadable({ loader: () => import('pages/TeamPage/TeamPage'), loading })
const CareersPage                     = Loadable({ loader: () => import('pages/CareersPage/CareersPage'), loading })
const PayPalLandingPage               = Loadable({ loader: () => import('pages/PayPalLandingPage/PayPalLandingPage'), loading })
const InvitePage                      = Loadable({ loader: () => import('pages/InvitePage/InvitePage'), loading })
const MainPage                        = Loadable({ loader: () => import('pages/MainPage/MainPage'), loading })
const SmartSearchPage                 = Loadable({ loader: () => import('pages/SmartSearchPage/SmartSearchPage'), loading })
const FeaturedPage                    = Loadable({ loader: () => import('pages/FeaturedPage/FeaturedPage'), loading })
const ExtrasPage                      = Loadable({ loader: () => import('pages/ExtrasPage/ExtrasPage'), loading })
const RecommendationsPage             = Loadable({ loader: () => import('pages/RecommendationsPage/RecommendationsPage'), loading })
const FragranceOfTheMonthPage         = Loadable({ loader: () => import('pages/FragranceOfTheMonthPage/FragranceOfTheMonthPage'), loading })
const BrandPage                       = Loadable({ loader: () => import('pages/BrandPage/BrandPage'), loading })
const ThankYouPage                    = Loadable({ loader: () => import('pages/ThankYouPage/ThankYouPage'), loading })
const SpecialPage                     = Loadable({ loader: () => import('pages/SpecialPage/SpecialPage'), loading })
const SuccessfulVerificationPage      = Loadable({ loader: () => import('pages/SuccessfulVerificationPage/SuccessfulVerificationPage'), loading })
const FacebookEmailRegistrationPage   = Loadable({ loader: () => import('pages/FacebookEmailRegistrationPage/FacebookEmailRegistrationPage'), loading })
const CasePrizePage                   = Loadable({ loader: () => import('pages/CasePrizePage/CasePrizePage'), loading })
const PressPage                       = Loadable({ loader: () => import('pages/PressPage/PressPage'), loading })
const ScentbirdReviewsPage            = Loadable({ loader: () => import('pages/ScentbirdReviewsPage/ScentbirdReviewsPage'), loading })
const GiftCardTermsPage               = Loadable({ loader: () => import('pages/GiftCardTermsPage/GiftCardTermsPage'), loading })
const ClaimGiftCardPage               = Loadable({ loader: () => import('pages/ClaimGiftCardPage/ClaimGiftCardPage'), loading })
const CollectionLandingPage           = Loadable({ loader: () => import('pages/CollectionLandingPage/CollectionLandingPage'), loading })
const CollectionsPage                 = Loadable({ loader: () => import('pages/CollectionsPage/CollectionsPage'), loading })
const CollectionPage                  = Loadable({ loader: () => import('pages/CollectionPage/CollectionPage'), loading })
const CouponsPage                     = Loadable({ loader: () => import('pages/CouponsPage/CouponsPage'), loading })
const PopularInStatesPage             = Loadable({ loader: () => import('pages/PopularInStatesPage/PopularInStatesPage'), loading })
const RequestPage                     = Loadable({ loader: () => import('pages/RequestPage/RequestPage'), loading })
const TrackingPage                    = Loadable({ loader: () => import('pages/TrackingPage/TrackingPage'), loading })
const FragranceFinderPage             = Loadable({ loader: () => import('pages/FragranceFinderPage/FragranceFinderPage'), loading })
const QueuePage                       = Loadable({ loader: () => import('pages/QueuePage/QueuePage'), loading })
const FlashSaleBundlePage             = Loadable({ loader: () => import('pages/bundle/FlashSaleBundlePage/FlashSaleBundlePage'), loading })
const FathersDayGiftSetPage           = Loadable({ loader: () => import('pages/bundle/FathersDayGiftSetPage/FathersDayGiftSetPage'), loading })
const CaseMonthlyDesignPage           = Loadable({ loader: () => import('pages/CaseMonthlyDesignPage/CaseMonthlyDesignPage'), loading })
const CaseSubscriptionPage            = Loadable({ loader: () => import('pages/CaseSubscriptionPage/CaseSubscriptionPage'), loading })
const MembershipPage                  = Loadable({ loader: () => import('pages/MembershipPage/MembershipPage'), loading })
const ImproveSurveyPage               = Loadable({ loader: () => import('pages/ImproveSurveyPage/ImproveSurveyPage'), loading })
const ImproveRecommendationsPage      = Loadable({ loader: () => import('pages/ImproveRecommendationsPage/ImproveRecommendationsPage'), loading })
const NoteProductsPage                = Loadable({ loader: () => import('pages/NoteProductsPage/NoteProductsPage'), loading })
const CollectionForSalePage           = Loadable({ loader: () => import('pages/CollectionForSalePage/CollectionForSalePage'), loading })
const CollectionsForSalePage          = Loadable({ loader: () => import('pages/CollectionsForSalePage/CollectionsForSalePage'), loading })

const EmailUnsubscribePage            = Loadable({ loader: () => import('pages/EmailUnsubscribePage/EmailUnsubscribePage'), loading })

// onboarding quiz
const QuizPage                        = Loadable({ loader: () => import('pages/QuizPage/QuizPage'), loading })
const QuizProductPage                 = Loadable({ loader: () => import('pages/QuizProductPage/QuizProductPage'), loading })

// gifts
const GiftPage                        = Loadable({ loader: () => import('pages/GiftPage/GiftPage'), loading })
const GiftsPage                       = Loadable({ loader: () => import('pages/GiftsPage/GiftsPage'), loading })
const GiftCardPage                    = Loadable({ loader: () => import('pages/GiftCardPage/GiftCardPage'), loading })
const GiftSetsPage                    = Loadable({ loader: () => import('pages/giftSets/GiftSetsPage/GiftSetsPage'), loading })
const GiftSetPage                     = Loadable({ loader: () => import('pages/giftSets/GiftSetPage/GiftSetPage'), loading })

// horoscope
const HoroscopePage                   = Loadable({ loader: () => import('pages/horoscope/HoroscopePage/HoroscopePage'), loading })
const ZodiacSignPage                  = Loadable({ loader: () => import('pages/horoscope/ZodiacSignPage/ZodiacSignPage'), loading })

// auth
const LoginPage                       = Loadable({ loader: () => import('pages/auth/LoginPage/LoginPage'), loading })
const RegisterPage                    = Loadable({ loader: () => import('pages/auth/RegisterPage/RegisterPage'), loading })
const ResetPasswordPage               = Loadable({ loader: () => import('pages/auth/ResetPasswordPage/ResetPasswordPage'), loading })
const RemindPasswordPage              = Loadable({ loader: () => import('pages/auth/RemindPasswordPage/RemindPasswordPage'), loading })

// search result
const SearchResultPage                = Loadable({ loader: () => import('pages/SearchResultPage/SearchResultPage'), loading })

// landing
const PopupShopPage                   = Loadable({ loader: () => import('pages/PopupShopPage/PopupShopPage'), loading })
const ReferralLandingPage             = Loadable({ loader: () => import('pages/ReferralLandingPage/ReferralLandingPage'), loading })

// taste maker
const TasteMakerPage                  = Loadable({ loader: () => import('pages/TasteMakerPage/TasteMakerPage'), loading })

// incubator page
const IncubatorPage                   = Loadable({ loader: () => import('pages/IncubatorPage/IncubatorPage'), loading })
const FragranceConceptsPage           = Loadable({ loader: () => import('pages/FragranceConceptsPage/FragranceConceptsPage'), loading })
const IncubatorTestPage               = Loadable({ loader: () => import('pages/IncubatorTestPage/IncubatorTestPage'), loading })
const IncubatorQueue                  = Loadable({ loader: () => import('pages/incubator/QueuePage/QueuePage'), loading })

// internal test new recommendations prototype
const TestRecommendationsPage         = Loadable({ loader: () => import('pages/TestRecommendationsPage/TestRecommendationsPage'), loading })

// ScentBeat
const PickPlaylistPage                = Loadable({ loader: () => import('pages/scentBeatFlow/PickPlaylistPage/PickPlaylistPage'), loading })

// Hackathon task
const HowToChoose                     = Loadable({ loader: () => import('pages/HowToChoose/HowToChoose'), loading })

// Hackathon task
// const MakeupOnFacePage                = Loadable({ loader: () => import('pages/MakeupOnFacePage/MakeupOnFacePage'), loading })

const isTestRecommendationsPageEnabled = config.runEnv !== 'prod'

const SiteHealth                      = () => null

const getCosmeticsPageRoutes = (structure) => {
  const routes = []

  const getRouteData = (structure) => {
    structure.forEach(({ children, ...item }) => {
      if (item.url) {
        routes.push({
          url: item.url,
          data: item,
        })
      }

      if (children) {
        getRouteData(children)
      }
    })
  }

  if (structure) {
    Object.values(structure).forEach((children) =>
      getRouteData(children)
    )
  }

  return routes.map(({ url, data }) => (
    <Route
      key={data.root}
      path={url}
      exact
      render={(props) => <CosmeticsProductsPageNew data={data} {...props} />}
    />
  ))
}

const RegistrationLayout = ({ isHumbleRegisterPageEnabled, isNewRegistrationViewEnabled, ...props }) => {
  if (isHumbleRegisterPageEnabled || isNewRegistrationViewEnabled) {
    return <HumbleLayout {...props} withBgColor={!isNewRegistrationViewEnabled} />
  }

  return <WithoutHeaderLayout {...props} />
}

const QuizPageLayout = ({ isRecsNewQuizPageEnabled, ...props }) => {
  if (isRecsNewQuizPageEnabled) {
    return <HumbleLayout {...props} />
  }

  return <WithoutHeaderLayout {...props} />
}

const RecommendationsPageLayout = ({ isRecsNewQuizPageEnabled, ...props }) => {
  if (isRecsNewQuizPageEnabled) {
    return <HumbleLayout {...props} />
  }

  const { children } = props

  return (
    <InsideLayout withSubHeader>
      <SubscriptionLayout>
        {children}
      </SubscriptionLayout>
    </InsideLayout>
  )
}

const getRoutes = ({ features, abTests, device, initialDevice = {}, cosmeticsDataStructure }) => {
  const isMobile                              = initialDevice.isMobile || device.isMobile
  const isHumbleRegisterPageEnabled           = isMobile
  const isTossInEnabled                       = features[constants.features.tossIn]
  const isPasswordRestoreWithTokenEnabled     = features[constants.features.passwordRestoreWithToken]
  const isProductPageForExtrasEnabled         = features[constants.features.productPageForExtras]
  const isFatherDayBambooGiftSetEnabled       = features[constants.features.fatherDayBambooGiftSet]
  const isRecommendationsImproveEnabled       = features[constants.features.recommendationsImprove]
  const isUnpauseOffersEnabled                = features[constants.features.unpauseOffers]
  const isWelcomePageRemoved                  = features[constants.features.removeWelcomePage]
  const isUpgradeProductPageEnabled           = features[constants.features.upgradeProductPage]
  const isNotesProductPageEnabled             = features[constants.features.productsBasedOnNotes]
  const isCollectionForSalePageEnabled        = features[constants.features.collectionsForSale]
  const isPrepaidPlansLandingPageEnabled      = features[constants.features.prepaidPlansLandingPage]
  const isGiftsHidden                         = features[constants.features.hideGifts]
  const isTasteMakerLandingPageEnabled        = features[constants.features.tasteMakersLanding]

  const isNewRegistrationViewEnabled  = !isMobile && getAbValue(constants.abTests.newRegistrationView, abTests) === 'b'
  const isRecsNewQuizPageEnabled      = getAbValue(constants.abTests.recsNewQuiz, abTests) === 'b'

  const cosmeticsProductsPageRoutes  = getCosmeticsPageRoutes(cosmeticsDataStructure)

  return (
    <App>
      <Switch>

        <Route path="/site-health" component={SiteHealth} />
        <Route path="/check-helmet" component={CheckHelmet} />
        {/* <Route path="/how-to-choose" component={HowToChoose} /> */}

        {/* ---------------------------------------     NO AUTH     --------------------------------------- */}


        <Redirect exact from={links.subscription.root} to={links.subscription.mainWomen} />
        <Redirect exact from={links.userProfile.root} to={links.userProfile.receivedProducts} />

        <Redirect exact from={links.profile.root} to={links.profile.ordersStatus} />
        {/* /!* TODO move this redirect to nginx *!/ */}
        <Redirect exact from="/profile/rated-fragrances" to={links.profile.ratedProducts} />
        {/* /!* TODO move this redirect to nginx *!/ */}
        <Redirect exact from="/profile/fragrances-in-queue" to={links.profile.productsInQueue} />

        {/* TODO: for temporary redirects! SCNT-4477 */}
        <Redirect exact from="/lip-balms" to={links.bodyLip} />
        <Redirect exact from="/scrub/:slug" to={links.productPageBody} />
        <Redirect exact from="/scrubs/:slug" to={links.productPageBody} />
        <Redirect exact from="/lip-balm/:slug" to={links.productPageBodyLip} />
        <Redirect exact from="/lip-balms/:slug" to={links.productPageBodyLip} />


        {/* NO Header, NO Footer */}

        {
          isWelcomePageRemoved ? (
            <Redirect exact from={links.welcome} to={links.pick} />
          ) : (
            <Route path={links.welcome} exact component={WelcomePage} />
          )
        }
        <Route path={links.case} exact component={CasesSubscriptionPage} />
        <Route path={links.pick} exact component={PickPage} />
        <Route path={links.request} exact component={RequestPage} />
        <Route path={links.makeupLanding} exact component={MakeupLandingPage} />
        <Route path={links.plan} exact component={PlanPage} />
        <Route path={links.collectionLanding} exact component={CollectionLandingPage} />
        <Route path={links.mixWelcome} exact component={MixWelcomePage} />

        {/* Scentbird Special */}
        <Route path={links.special} component={SpecialPage} />

        {/* ScentBeat */}
        <Route path={links.genres} exact component={PickPlaylistPage} />

        {/* NO Footer */}

        <WithoutHeaderLayout withFooter={false}>
          <Route path={links.successfulEmailVerification} exact component={SuccessfulVerificationPage} />
          <Route path={links.claimGiftCard} exact component={ClaimGiftCardPage} />
        </WithoutHeaderLayout>

        {/* NO Header */}

        {/* Quiz */}
        <Route path={links.choose} exact component={QuizPage} />

        <QuizPageLayout withFooter isRecsNewQuizPageEnabled={isRecsNewQuizPageEnabled}>
          <Route path={links.quiz} exact component={QuizPage} />
          <Route path={links.quizMen} exact component={QuizPage} />
        </QuizPageLayout>

        {/* Payment */}
        <Route path={links.subscribe} exact component={SubscribePage} />
        <Route path={links.giftCardPayment} exact component={GiftCardPaymentPage} />
        <Route path={links.giftSubscriptionPayment} exact component={GiftSubscriptionPaymentPage} />
        <Route path={links.giftRedeem} exact component={GiftSubscriptionRedeemPage} />
        <Route path={links.couponPayment} exact component={RedeemCouponPage} />

        {/* New Payment */}
        <Route path="/subscribe2" exact component={NewSubscribePage} />
        <Route path={links.subscribeNew} exact component={SubscribePrototypePage} />
        <Route path={links.queueRedeem} exact component={RedeemQueuePage} />
        <Route path={links.tossInRedeem} exact component={RedeemTossInPage} />

        {/* NO HeaderBanner, NO SubHeader, NO SearchInput */}

        <LandingLayout withSubHeader={false} withBanner={false} withSearchInput={false} withDiscountBanner>
          <Route path={links.skincareIntro} exact component={SkincareIntroPage} />
          <Route path={links.mix} exact component={MixPage} />
        </LandingLayout>

        <LandingLayout withSubHeader={false} withBanner={false} withSearchInput={false} headerColor="blue">
          <Route path={links.referralLanding} exact component={ReferralLandingPage} />
        </LandingLayout>

        {/* NO Header, Link logo */}

        {/* Register */}
        <RegistrationLayout
          isHumbleRegisterPageEnabled={isHumbleRegisterPageEnabled}
          isNewRegistrationViewEnabled={isNewRegistrationViewEnabled}
        >
          <Route path={links.register} exact component={RegisterPage} />
        </RegistrationLayout>

        <WithoutHeaderLayout withFooter logoLink={links.home}>
          <Route path={links.login} exact component={LoginPage} />
          {
            isPasswordRestoreWithTokenEnabled && (
              <Route path={links.resetPassword} exact component={ResetPasswordPage} />
            )
          }
          <Route path={links.remindPassword} exact component={RemindPasswordPage} />
          <Route path={links.facebookEmailRegistration} exact component={FacebookEmailRegistrationPage} />
        </WithoutHeaderLayout>

        {/* WITH HeaderBanner, NO SubHeader */}

        <InsideLayout withSubHeader={false} withBanner>
          <Route path={links.team} exact component={TeamPage} />
          <Route path={links.careers} exact component={CareersPage} />
          <Route path={links.howHandCreamsWork} exact component={HowHandCreamsWorkPage} />
          <Route path={links.howItWorks} exact component={HowItWorksPage} />
          <Route path={links.scentbirdReviews} exact component={ScentbirdReviewsPage} />
        </InsideLayout>

        {/* NO HeaderBanner, NO SubHeader */}

        <InsideLayout withSubHeader={false} withBanner={false}>
          <Route path={links.gift} exact component={GiftPage} />
          <Route path={links.giftFb} exact component={GiftPage} />
          <Route path={links.gifts} exact component={GiftsPage} />
          <Route path={links.press} exact component={PressPage} />
          <Route path={links.giftCard} exact component={GiftCardPage} />
          <Route path={links.giftCardTerms} exact component={GiftCardTermsPage} />
          <Route path={links.casePrize} exact component={CasePrizePage} />
        </InsideLayout>

        {/* NO HeaderBanner, NO SubHeader, NO SearchInput */}

        <InsideLayout withSubHeader={false} withBanner={false} withSearchInput={false}>
          <Route path={links.popupShop} exact component={PopupShopPage} />
        </InsideLayout>

        {/* WITH SubHeader */}

        <InsideLayout withSubHeader>
          <Route path={links.unsubscribe} exact component={EmailUnsubscribePage} />
          <Route path={links.blogger} exact component={BloggerPage} />
          {
            isGiftsHidden ? (
              <Fragment>
                <Redirect exact from={links.giftSet} to={links.gifts} />
                <Redirect exact from={links.giftSetsMen} to={links.gifts} />
              </Fragment>
            ) : (
              <Fragment>
                <Route path={links.giftSet} exact component={GiftSetsPage} />
                <Route path={links.giftSetsMen} exact component={GiftSetsPage} />
              </Fragment>
            )
          }
          <Route path={links.skincareSets} exact component={GiftSetsPage} />
          <Route path={links.newGiftSet} exact component={GiftSetPage} />
          <Route path={links.skincareSet} exact component={GiftSetPage} />
          <Route path={links.coupons} exact component={CouponsPage} />
          <Route path="/incubator/test" exact component={IncubatorTestPage} />
          {
            isTasteMakerLandingPageEnabled && (
              <Route path={links.tasteMaker} exact component={TasteMakerPage} />
            )
          }
        </InsideLayout>

        {/* WITH Queue */}

        <InsideLayout withSubHeader>
          <SubscriptionLayout>
            <Route path={links.subscription.mainMen} exact component={MainPage} />
            <Route path={links.subscription.mainWomen} exact component={MainPage} />
            <Route path={links.subscription.mainWomenEmpty} exact component={MainPage} />
            <Route path={links.subscription.mainMenEmpty} exact component={MainPage} />
            <Route path={links.brand} exact component={BrandPage} />
            <Route path={links.subscription.collectionsWomen} exact component={CollectionsPage} />
            <Route path={links.subscription.collectionsMen} exact component={CollectionsPage} />
            <Route path={links.productTypeCollectionMenNew} exact component={CollectionsPage} />
            <Route path={links.productTypeCollectionWomenNew} exact component={CollectionsPage} />
            <Redirect exact from={links.productTypeCollectionMen} to={links.productTypeCollectionMenNew} />
            <Redirect exact from={links.productTypeCollectionWomen} to={links.productTypeCollectionWomenNew} />
            <Route path={links.collectionWomen} exact component={CollectionPage} />
            <Route path={links.collectionMen} exact component={CollectionPage} />
            <Route path={links.skincareCollectionItemWomenNew} exact component={CollectionPage} />
            <Route path={links.skincareCollectionItemMenNew} exact component={CollectionPage} />
            <Route path={links.popularInStates} exact component={PopularInStatesPage} />

            {/* TODO rework to two routes w/o exact. Beware about snowplow context, ask @pivanov */}
            <Route path={links.subscription.perfumeOfTheMonth} exact component={FragranceOfTheMonthPage} />
            <Route path={links.subscription.cologneOfTheMonth} exact component={FragranceOfTheMonthPage} />
            <Route path={links.subscription.currPerfumeOfTheMonth} exact component={FragranceOfTheMonthPage} />
            <Route path={links.subscription.currCologneOfTheMonth} exact component={FragranceOfTheMonthPage} />

            { /* Skincare and Wellness */ }

            <Fragment>
              {cosmeticsProductsPageRoutes}
            </Fragment>

            { /* Makeup */ }
            <Route path={links.makeup} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupPalettes} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEye} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyeMascara} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyeEyebrow} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyeTreatment} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyeEyeliner} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyePrimer} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupEyeEyeshadow} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupLip} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupLipLiner} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupLipLipstick} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupLipLipgloss} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupFace} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupFacePrimer} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupConcealer} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupFaceFoundation} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupCheek} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupCheekBlush} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupCheekHighlight} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupTools} exact component={CosmeticsProductsPage} />
            <Route path={links.makeupToolsBrushes} exact component={CosmeticsProductsPage} />

            { /* Personal care */ }
            <Route path={links.personalCare} exact component={CosmeticsProductsPage} />
            <Route path={links.personalCareShower} exact component={CosmeticsProductsPage} />
            <Route path={links.personalCareHandCreams} exact component={CosmeticsProductsPage} />
            <Route path={links.personalCareShowerBodyWash} exact component={CosmeticsProductsPage} />
            <Route path={links.personalCareShowerBodyScrub} exact component={CosmeticsProductsPage} />
            <Route path={links.personalCareBodyMoisturizers} exact component={CosmeticsProductsPage} />

            <Route path={links.candles} exact component={ProductsPage} />
            <Route path={links.newProducts} exact component={ProductsPage} />
            <Route path={links.makeupBrand} exact component={ProductsPage} />
            <Route path={links.bestsellersMen} exact component={ProductsPage} />
            <Route path={links.bestsellersWomen} exact component={ProductsPage} />
            <Route path={links.scentbirdProducts} exact component={ProductsPage} />
            <Route path={links.fragranceFinder} exact component={FragranceFinderPage} />
          </SubscriptionLayout>
        </InsideLayout>

        {/* Product page */}

        <InsideLayout withSubHeader>
          <Route path={links.productPageCommonProduct} exact component={ProductPage} isProduct />
          <Route path={links.productPagePerfumes} exact component={ProductPage} isProduct />
          <Route path={links.productPagePerfume} exact component={ProductPage} isProduct />
          <Route path={links.productPageHandCreams} exact component={ProductPage} isProduct />
          <Route path={links.productPageHandCream} exact component={ProductPage} isProduct />
          <Route path={links.productPageBodyLip} exact component={ProductPage} isProduct />
          <Route path={links.productPageBody} exact component={ProductPage} isProduct />
          <Route path={links.productPageShowerGels} exact component={ProductPage} isProduct />
          <Route path={links.productPageShowerGel} exact component={ProductPage} isProduct />
          <Route path={links.productPageCandles} exact component={ProductPage} isProduct />
          <Route path={links.productPageCandle} exact component={ProductPage} isProduct />
          <Route path={links.productMakeup} exact component={ProductPage} isProduct />
          <Route path={links.productPersonalCare} exact component={ProductPage} isProduct />
          {
            isProductPageForExtrasEnabled ? (
              <Fragment>
                <Route path={links.productExtra} exact component={ProductPage} isProduct />
                <Route path={links.productExtras} exact component={ProductPage} isProduct />
              </Fragment>
            ) : (
              <Fragment>
                <Redirect exact from={links.productExtra} to={links.subscription.extras} />
                <Redirect exact from={links.productExtras} to={links.subscription.extras} />
              </Fragment>
            )
          }
          <Route path={links.productSkincare} exact component={ProductPage} isProduct />
          <Route path={links.productLanding} exact component={ProductPage} isProduct />
        </InsideLayout>

        {/* Horoscope */}

        <InsideLayout withBreadcrumbs>
          <Route path={links.zodiacSign} exact component={ZodiacSignPage} />
          <Route path={links.horoscope} exact component={HoroscopePage} />
        </InsideLayout>

        {/* User Profile */}

        <InsideLayout withSubHeader>
          <UserProfileLayout>
            <Route path={links.userProfile.receivedProducts} exact component={ReceivedProductsPage} />
            <Route path={links.userProfile.productsInQueue} exact component={ProductsInQueuePage} />
            <Route path={links.userProfile.ratedProducts} exact component={RatedProductsPage} />
            <Route path={links.userProfile.reviews} exact component={ReviewsPage} />
          </UserProfileLayout>
        </InsideLayout>


        {/* ---------------------------------------     HAS AUTH     --------------------------------------- */}


        {/* NO HEADER NO FOOTER */}

        <HasAuth>

          <Route path={links.checkout} exact component={PaymentPage} />
          <Route path={links.thankYou} exact component={ThankYouPage} />
          <Route path={links.membership} exact component={MembershipPage} />

          <Route path={links.cancelSubscription} exact component={CancelSubscriptionPage} />

          {/* NO HEADER */}

          <WithoutHeaderLayout withFooter>
            <Route path={links.quizProduct} exact component={QuizProductPage} />
            <Route path={links.incubator.fragranceConcepts} exact component={FragranceConceptsPage} />
            <Route path={links.improveSurvey} exact component={ImproveSurveyPage} />
          </WithoutHeaderLayout>

          {
            isRecommendationsImproveEnabled && (
              <WithoutHeaderLayout withFooter logoCenter>
                <Route path={links.improveRecommendations} exact component={ImproveRecommendationsPage} />
              </WithoutHeaderLayout>
            )
          }

          {/* NO SubHeader */}

          <InsideLayout withSubHeader={false}>
            <Route path={links.resub} exact component={ResubscribePage} />
            <Route path={links.resubscribe} exact component={ResubscribePage} />
            <Route path={links.resubscribe3} exact component={ResubscribePage} />
            <Route path={links.resubscribe5} exact component={ResubscribePage} />
            <Route path={links.resubscribe50} exact component={ResubscribePage} />
            <Route path={links.resubscribeFree} exact component={ResubscribePage} />
            <Route path={links.resubscribe5mo12} exact component={ResubscribePage} />
            <Route path={links.payPalUpdate} exact component={PayPalLandingPage} />
            {
              isUnpauseOffersEnabled && (
                <Fragment>
                  <Route path={links.unpause} exact component={UnpausePage} />
                  <Route path={links.unpause50} exact component={UnpausePage} />
                </Fragment>
              )
            }
          </InsideLayout>

          {/* WITH SubHeader, NO HeaderBanner */}

          <InsideLayout withSubHeader withBanner={false} withSearchInput={false}>
            <Route path={links.incubator.neonHeat} exact component={IncubatorPage} />
            <Route path={links.buyQueue} exact component={BuyQueuePage} />
          </InsideLayout>

          {/* WITH SubHeader */}

          <InsideLayout withSubHeader>
            <Route path={links.cardUpdate} exact component={CardUpdatePage} />
            <Route path={links.cardUpdate50} exact component={CardUpdatePage} />
            <Route path={links.caseCardUpdate} exact component={CaseCardUpdatePage} />
            <Route path={links.upgrade} exact component={UpgradePage} />
            <Route path={links.downgrade} exact component={DowngradePage} />
            <Route path={links.upgradePlan} exact component={UpgradeSimplePage} />
            {
              isUpgradeProductPageEnabled && (
                <Route path={links.upgradeProduct} exact component={UpgradeProductPage} />
              )
            }
            {
              isPrepaidPlansLandingPageEnabled && (
                <Route path={links.upgradePrepaid} exact component={UpgradePrepaidPage} />
              )
            }
            <Route path={links.upgradeWithDiscount} exact component={UpgradePlanWithDiscountPage} />
            {/* <Route path={links.thankYou} exact component={ThankYouPage} /> */}
            <Route path={links.caseMonthlyDesign} exact component={CaseMonthlyDesignPage} />
            <Route path={links.invite} exact component={InvitePage} />
            <Route path={links.fInvite} exact component={InvitePage} />
            <Route path={links.mInvite} exact component={InvitePage} />
            <Route path={links.searchResult} exact component={SearchResultPage} />
            {
              isTossInEnabled && (
                <Route path={links.tossIn} exact component={TossInPage} />
              )
            }
            <Route path={links.tracking} exact component={TrackingPage} />
            <Route path={links.queue} exact component={QueuePage} />
            <Route path={links.incubator.queue} exact component={IncubatorQueue} />
            <Route path={links.flashSale} exact component={FlashSaleBundlePage} />
            <Route path={links.caseSubscription} exact component={CaseSubscriptionPage} />
            {
              isFatherDayBambooGiftSetEnabled && (
                <Route path={links.fathersDayGiftSet} exact component={FathersDayGiftSetPage} />
              )
            }
            {
              isNotesProductPageEnabled && (
                <Fragment>
                  <Route path={links.noteWomen} exact component={NoteProductsPage} />
                  <Route path={links.noteMen} exact component={NoteProductsPage} />
                </Fragment>
              )
            }
            {
              isCollectionForSalePageEnabled && (
                <Fragment>
                  <Route path={links.collectionsForSale} exact component={CollectionsForSalePage} />
                  <Route path={links.collectionForSale} exact component={CollectionForSalePage} />
                </Fragment>
              )
            }
          </InsideLayout>

          {/* WITH Queue */}

          <InsideLayout withSubHeader>
            <SubscriptionLayout>
              <Route path={links.subscription.smartSearch} exact component={SmartSearchPage} />
              <Route path={links.subscription.perfumes} exact component={SmartSearchPage} />
              <Route path={links.subscription.colognes} exact component={SmartSearchPage} />
              <Route path={links.subscription.bestsellers} exact component={SmartSearchPage} />
              <Route path={links.subscription.bestsellersAll} exact component={SmartSearchPage} />
              <Route path={links.subscription.newArrivals} exact component={SmartSearchPage} />
              <Route path={links.subscription.featured} exact component={FeaturedPage} />
              <Route path={links.subscription.extras} exact component={ExtrasPage} />
            </SubscriptionLayout>
          </InsideLayout>

          {/* recsNewQuiz ab - "no footer & header" vs old "inside with queue" */}

          <RecommendationsPageLayout isRecsNewQuizPageEnabled={isRecsNewQuizPageEnabled}>
            <Route path={links.subscription.recommendations} exact component={RecommendationsPage} />
          </RecommendationsPageLayout>

          {/* My Profile */}

          <InsideLayout withSubHeader>
            <ProfileLayout>
              <ProfileSubscriptionLayout>
                <Route path={links.profile.ordersStatus} exact component={OrdersStatusPage} />
                <Route path={links.profile.upgradeSubscription} exact component={UpgradeSubscriptionPage} />
                <Route path={links.profile.productsInQueue} exact component={ProductsInQueuePage} />
                <Route path={links.profile.ratedProducts} exact component={RatedProductsPage} />
                <Route path={links.profile.reviews} exact component={ReviewsPage} />
              </ProfileSubscriptionLayout>
              <ProfileContentLayout>
                <Route path={links.profile.billingAndShipping} exact component={BillingAndShippingPage} />
                <Route path={links.profile.password} exact component={UpdatePasswordPage} />
                <Route path={links.profile.sentGifts} exact component={SentGiftsPage} />
                <Route path={links.profile.myOrders} exact component={MyOrdersPage} />
                <Route path={links.profile.order} exact component={OrderInfoPage} />
                <Route path={links.profile.personal} exact component={PersonalPage} />
              </ProfileContentLayout>
            </ProfileLayout>
          </InsideLayout>

        </HasAuth>

        {/* Try makeup on face */}
        {/* <Route path={links.makeupOnFace} exact component={MakeupOnFacePage} /> */}

        {
          isTestRecommendationsPageEnabled && (
            <Route path="/test-recommender" exact component={TestRecommendationsPage} />
          )
        }
        {
          process.env.WEBPACK === 'dev' && (
            <Route path="/404" exact component={Page404} />
          )
        }
        <Route component={NoMatch} />

      </Switch>
    </App>
  )
}


export default getRoutes
